import type {ReactElement} from 'react';
import {useState} from 'react';
import {resolveChatOptionImageUrl} from '@Libraries/chat-media-url.library';
import type {SurveyOptionImageProps} from './survey-option-image.types';

export function SurveyOptionImage({imageUrl, className, alt}: SurveyOptionImageProps): ReactElement | null {
  const [failedImageUrl, setFailedImageUrl] = useState<string | null>(null);
  const resolvedImageUrl = resolveChatOptionImageUrl(imageUrl);

  if (failedImageUrl === imageUrl || resolvedImageUrl === null) {
    return null;
  }

  return (
    <img
      className={className}
      src={resolvedImageUrl}
      alt={alt}
      onError={(): void => {
        setFailedImageUrl(imageUrl);
      }}
    />
  );
}
